// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React from 'react';

import {usePanelComments} from '../../../state/reports/usePanelComments';
import {usePanelContext} from '../../Panel/PanelContextProvider';

export const PanelAddComment = () => {
  const {panelRef, isReadOnly} = usePanelContext();
  const {addComment} = usePanelComments({
    panelRef,
  });

  // Do not show this action if it's a draft report (aka it's being edited)
  if (!isReadOnly) {
    return null;
  }

  return (
    <Button
      icon="forum-chat-bubble"
      tooltip="Add a comment"
      tooltipProps={{className: 'py-8 px-12'}}
      variant="ghost"
      size="small"
      name="chat"
      title="Add comment"
      aria-label="Add comment"
      className="mr-8"
      onClick={addComment}
    />
  );
};
